<template>
    <gofix-card :title="section" fullContent class="gofixCardChecklist mb-0" classHeader="pl-25" collapse>
        <div class="gofixBasicTable">
            <div class="dataList">
                <b-table :tbody-tr-class="rowClass" :fields="fields" :responsive="true" :items="item.checklist_entries" fixed class="mb-0">
                    <template slot="input" slot-scope="row">
                        {{ row.item.input.data_type ? row.item.input.data_type : '-' }}
                    </template>
                    <template slot="value" slot-scope="row">
                        <template v-if="row.item.status != 'NA'">
                            <b-form-checkbox @input="getCheckListPreEntryValue(row.item)" v-if="!row.item.input.data_type || row.item.input.data_type === 'Checkbox'" :disabled="!isAllowEditPreEntryValue" v-model="row.item.input.value"></b-form-checkbox>
                            <gofix-form-input @change="getCheckListPreEntryValue(row.item)" class="m-0" label v-if="row.item.input.data_type === 'Free text'" :disabled="!isAllowEditPreEntryValue" v-model="row.item.input.value"></gofix-form-input>
                            <div class="d-flex align-items-center" v-if="row.item.input.data_type === 'Reading'">
                                <gofix-form-input-number 
                                @change="checkReadingTypeValidate(row.item)"
                                @input="resetCheckReadingTypeValidate(row.item)"
                                @focus="handleFocus(arguments[0], row.item)"
                                label class="m-0"
                                :includeThousandsSeparator="false"
                                allowNegative
                                :class="{ 'form-input--error': row.item.status === 'Filled' && !row.item.input.value }"
                                :disabled="!isAllowEditPreEntryValue"
                                v-model="row.item.input.value"></gofix-form-input-number>
                                <span class="ml-1 d-block nowrap" v-if="row.item.input.unit">{{row.item.input.unit}}</span>
                            </div>
                            <gofix-form-dropdown @input="getCheckListPreEntryValue(row.item)" class="m-0" label v-if="row.item.input.data_type === 'Dropdown'" :disabled="!isAllowEditPreEntryValue" v-model="row.item.input.value" :options="row.item.input.possible_value"></gofix-form-dropdown>
                        </template>
                        <template v-else>
                            <span class="na-status">--</span>
                        </template>
                    </template>
                    <template slot="status" slot-scope="row">
                        <gofix-form-dropdown 
                            :clearable="false" class="m-0" 
                            label 
                            @change="changeChecklistPreEntryStatus(row.item)" 
                            v-model="row.item.status" 
                            :disabled="!isAllowEditPreEntryStatus"
                            :options="checkListPreEntryStatus">
                        </gofix-form-dropdown>
                    </template>
                </b-table>
            </div>
        </div>
    </gofix-card>
</template>

<script>
import { mapGetters } from "vuex";
    export default {
        name: 'checklist-pre-entry-item',
        components: { },
        props: {
            item: {
                type: Object,
                default: () => {}
            },
            section: {
                type: String,
                default: null
            }
        },
        data() {
            return{
                fields: [
                    {
                        key: 'sequence',
                        label: 'Number',
                        thStyle: 'width: 132px',
                        thClass: 'pl-25',
                        tdClass: 'pl-25',
                    },
                    {
                        key: 'name',
                        label: 'Service Description',
                        thStyle: 'width: 240px'
                    },
                    {
                        key: 'input',
                        label: 'Value Type',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'value',
                        label: 'Value',
                        thStyle: 'width: 150px'
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        thStyle: 'width: 130px'
                    },
                ],
                checkListPreEntryStatus: [
                    'Filled',
                    'Unfilled',
                    'NA'
                ],
                checkListPreEntryUpdate: [],
                loading:false,
                modal: {
                    issue: {
                        open: false,
                        preset_actions: null,
                        checklistId: null
                    },
                    sla: {
                        open: false,
                        loading: false,
                        service_category_id: null
                    },
                },
                timer: {
                    issue: null
                }
            }
        },
        computed: {
            ...mapGetters({
                Item: "JobController/Item",
            }),
            isAllowEditPreEntryRemark() {
                // if(!this.Item || !this.Item.editing_of_checklist_action || !this.Item.editing_of_checklist_action.is_allow_edit_entry_remark) return false;
                if ( this.Item.job_status != 'Planned' && this.Item.job_status != 'Due' ) {
                    return false;
                }
                return true;
            },
            isAllowEditPreEntryStatus() {
                // if(!this.Item || !this.Item.editing_of_checklist_action || !this.Item.editing_of_checklist_action.is_allow_edit_entry_status) return false;
                if ( this.Item.job_status != 'Planned' && this.Item.job_status != 'Due' ) {
                    return false;
                }
                return true;
            },
            isAllowEditPreEntryValue() {
                // if(!this.Item || !this.Item.editing_of_checklist_action || !this.Item.editing_of_checklist_action.is_allow_edit_entry_value) return false;
                if ( this.Item.job_status != 'Planned' && this.Item.job_status != 'Due' ) {
                    return false;
                }
                return true;
            }   
        },
        created() {
            
        },
        methods: {
            rowClass(item, type){
                if(item && item.hasOwnProperty('is_output_highlighted') && item.is_output_highlighted == true){
                    if(item.input && item.input.data_type && item.input.data_type === "Reading" && item.is_output_highlighted){
                        return 'row-outside-value';
                    }
                }
                return;
            },
            handleFocus (value, item) {
                item.value_old = value;
                item.output_old = item.output;
                item.is_output_highlighted_old = item.is_output_highlighted;
                this.$emit('inputType', true)
            },
            resetCheckReadingTypeValidate(item) {
                if(item.hasOwnProperty('is_check_threshold') && item.is_check_threshold) item.is_check_threshold = false
            },
            async getCheckListPreEntryValue(val){
                this.$emit('updateCheckListPreEntries', { val:val, from_status: false});
            },
            async checkReadingTypeValidate(item){
                let result = await this.getMinMax(item);
                
                if(result.is_output_highlighted){
                    await this.$bvModal.msgBoxConfirm('Your value exceeds the threshold. Are you sure to keep the record?', {
                        title: 'Warning!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'OK',
                        cancelTitle: 'CANCEL',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true,
                        id: 'msgConfirm'
                    })
                    .then(value => {
                        if(value) {
                            item.input.value = parseFloat(item.input.value);
                            item.is_output_highlighted = result.is_output_highlighted;
                            item.output = result.output;
                        } else{
                            item.input.value = item.value_old ? item.value_old : null;
                            item.is_output_highlighted = item.is_output_highlighted_old;
                            item.output = item.output_old;
                        }
                    })
                } else {
                    item.is_output_highlighted = result.is_output_highlighted;
                    item.output = result.output;
                }
                this.getCheckListPreEntryValue(item);
            },
            async getMinMax(item) {
                let data = {};
                await this.$store.dispatch("JobController/getCheckListCalculated", {
                    id: item.id,
                    data: {
                        input: item.input
                    },
                }).then(result => {
                    data = Object.assign(data, result);
                });
                return data;
            },
            async changeChecklistPreEntryStatus(item){
                switch (item.status) {
                    case 'Filled':
                        if(!item.input.value) {
                            if(item.input.data_type === 'Checkbox'){
                                item.input.value = true;
                            } else {
                                this.$alertNotification('Please enter checklist entries value when the status Filled!','danger');
                            }
                        }
                        break;
                    case 'Unfilled':
                        item.input.value = null;
                        break;
                    case 'NA':
                        item.input.value = null;
                        break;
                }
                this.$emit('updateCheckListPreEntries',{val:item,from_status:true});
            },
        }
    }
</script>
